import { Link } from 'react-router-dom';

export default function Footer() {
  const quickLinks = [
    { to: '/', label: '首页' },
    { to: '/category/star', label: '明星八卦' },
    { to: '/category/expose', label: '黑料实锤' },
    { to: '/category/variety', label: '综艺热瓜' },
    { to: '/category/internet-celebrity', label: '网红爆料' },
    { to: '/category/drama', label: '影视吃瓜' },
    { to: '/about', label: '关于我们' },
  ];

  const hotTags = [
    '顶流塌房', '综艺黑幕', '网红翻车',
    '明星恋情', '偷税漏税', '潜规则',
    'CP分手', '解约风波',
  ];

  return (
    <footer className="bg-background-900 border-t border-background-800/50">
      <div className="w-full px-4 md:px-6 py-10 md:py-14">
        <div className="max-w-7xl mx-auto">
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            <div>
              <div className="flex items-center gap-2 mb-4">
                <div className="w-9 h-9 flex items-center justify-center bg-primary-500 rounded-lg">
                  <i className="ri-fire-fill text-background-50 text-lg"></i>
                </div>
                <span className="text-xl font-bold text-foreground-50">51吃瓜</span>
              </div>
              <p className="text-sm text-foreground-500 leading-relaxed mb-4">
                吃瓜不迷路，就上51吃瓜。全网最新、最全、最热的娱乐八卦资讯平台，
                为您提供明星八卦、网红爆料、综艺热瓜等精彩内容。
              </p>
              <div className="flex items-center gap-3">
                <a href="#" className="w-8 h-8 flex items-center justify-center rounded-full bg-background-800 text-foreground-400 hover:text-primary-400 hover:bg-background-700 transition-colors cursor-pointer" aria-label="微博">
                  <i className="ri-weibo-line"></i>
                </a>
                <a href="#" className="w-8 h-8 flex items-center justify-center rounded-full bg-background-800 text-foreground-400 hover:text-primary-400 hover:bg-background-700 transition-colors cursor-pointer" aria-label="微信">
                  <i className="ri-wechat-line"></i>
                </a>
                <a href="#" className="w-8 h-8 flex items-center justify-center rounded-full bg-background-800 text-foreground-400 hover:text-primary-400 hover:bg-background-700 transition-colors cursor-pointer" aria-label="抖音">
                  <i className="ri-tiktok-line"></i>
                </a>
              </div>
            </div>

            <div>
              <h3 className="text-sm font-semibold text-foreground-200 mb-4">快速导航</h3>
              <div className="grid grid-cols-2 gap-2">
                {quickLinks.map((link) => (
                  <Link
                    key={link.to}
                    to={link.to}
                    className="text-sm text-foreground-500 hover:text-primary-400 transition-colors whitespace-nowrap cursor-pointer"
                  >
                    {link.label}
                  </Link>
                ))}
              </div>
            </div>

            <div>
              <h3 className="text-sm font-semibold text-foreground-200 mb-4">热门标签</h3>
              <div className="flex flex-wrap gap-2">
                {hotTags.map((tag) => (
                  <span
                    key={tag}
                    className="px-3 py-1.5 text-xs rounded-full bg-background-800 text-foreground-400 border border-background-700/50 whitespace-nowrap"
                  >
                    {tag}
                  </span>
                ))}
              </div>
              <div className="mt-6 pt-4 border-t border-background-800/50">
                <p className="text-xs text-foreground-600">
                  联系邮箱：admin@51chigua.com
                </p>
                <p className="text-xs text-foreground-600 mt-1">
                  地址：北京市朝阳区望京SOHO
                </p>
              </div>
            </div>
          </div>

          <div className="mt-10 pt-6 border-t border-background-800/50 flex flex-col sm:flex-row items-center justify-between gap-4">
            <p className="text-xs text-foreground-600">
              &copy; 2020-2026 51吃瓜 版权所有 | 京ICP备XXXXXXXX号
            </p>
            <div className="flex items-center gap-4">
              <a href="#" className="text-xs text-foreground-600 hover:text-foreground-400 transition-colors whitespace-nowrap" rel="nofollow">隐私政策</a>
              <a href="#" className="text-xs text-foreground-600 hover:text-foreground-400 transition-colors whitespace-nowrap" rel="nofollow">用户协议</a>
              <a href="#" className="text-xs text-foreground-600 hover:text-foreground-400 transition-colors whitespace-nowrap" rel="nofollow">免责声明</a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}